/**
 * 引导
 */

export function getClickCollectOption() {
	return {
		showButtons: false,
		showBullets: false,
		steps: [
			{
				element: '.icon0',
				title: '提醒收藏',
				intro: `点击收藏将常用的产品放置在页面顶部，更快捷的找到产品入口！`,
				tooltipClass: 'custom-tooltip',
				position: 'top-middle',
			},
		],
	}
}

export function getClickCollectSortOption() {
	return {
		showButtons: false,
		showBullets: false,
		steps: [
			{
				element: '.icon0',
				title: '拖动收藏',
				intro: `长按拖动，可以按照自己使用习惯对收藏的产品进行排序！`,
				tooltipClass: 'custom-tooltip',
				position: 'top-middle',
			},
		],
	}
}
